import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getPDF } from "../services/http-service/getPDF";

export const useGetPDF = ({ orderItemDataPdf, enabled }: { orderItemDataPdf?: any; enabled?: boolean }) => {
  const {
    isLoading: loadingGetPDF,
    isFetching: fetchingGetPDF,
    isError: errorFetchingGetPDF,
    data: pdfBlob,
    error: errorGetPDFResponse,
    refetch: refetchGetPDF,
  } = useQuery({
    queryKey: ["GetPDF", orderItemDataPdf],
    queryFn: async () => {
      if (!orderItemDataPdf) {
        console.error("No data provided for PDF generation.");
      }

      const blob = await getPDF(orderItemDataPdf);

      const generatePdfFilename = (data: any) => {
        const orderIds = data?.orderIds?.map(String).join("_") || "Unknown";
        return `Order_${orderIds}_Shipment.pdf`;
      };

      const filename = generatePdfFilename(orderItemDataPdf);
      const url = window.URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      return blob;
    },
    enabled: enabled ?? false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
    staleTime: 0,
    cacheTime: 0,
  });

  const fetchGetPDFError = (errorGetPDFResponse as AxiosError)?.response?.data;

  return {
    loadingGetPDF,
    fetchingGetPDF,
    errorFetchingGetPDF,
    pdfBlob,
    fetchGetPDFError,
    refetchGetPDF,
  };
};
